import { getPercentageValue, getDownPaymentValue } from './getDownPayment.js';
import getDefaults from './getDefaults.js';

/**
 * Applies the Dealer.com settings we retrieved for this dealer to the selected criteria (input fields) in the
 * calculator configuration. After checking for defaults, we apply values for terms, credit type, down payments, mileage
 * options, and interest rates when they are not already set in the selected criteria.
 *
 * @param {Object} selectedCriteria - The existing selected criteria object from config.
 * @param {Object} settings - The DR settings API response object.
 * @param {('New'|'Used')} type - The type of vehicle.
 * @returns {Object} The transformed selected criteria object with default values applied where needed.
 */

const getTransformedSelectedCriteria = function () {
  let selectedCriteria = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let settings = arguments.length > 1 ? arguments[1] : undefined;
  let type = arguments.length > 2 ? arguments[2] : undefined;
  const {
    products
  } = settings || {};
  const defaults = getDefaults(settings, type, products?.hasLeasing);
  const {
    defaultLoanTerm,
    defaultCreditType,
    defaultInterestRates,
    defaultFinanceTermOptions,
    dealerSelectedLeaseTerm,
    dealerSelectedLeaseMileage,
    dealerLeaseMileageOptions,
    dealerLeaseTermOptions,
    creditLowScore
  } = defaults || {};
  const {
    selectedLoanTerm,
    selectedCreditType,
    financeDownPayment,
    leaseDownPayment,
    financeDownPaymentPercentage,
    leaseDownPaymentPercentage,
    selectedLeaseTerm,
    selectedLeaseMileage,
    leaseMileageOptions,
    leaseTermOptions,
    financeTermOptions,
    interestRate
  } = selectedCriteria || {};
  const listingType = type.toLowerCase();
  return {
    ...selectedCriteria,
    selectedLoanTerm: selectedLoanTerm ?? defaultLoanTerm,
    selectedCreditType: selectedCreditType ?? defaultCreditType,
    financeDownPayment: financeDownPayment ?? getDownPaymentValue(financeDownPayment, settings, type, 'financing'),
    leaseDownPayment: leaseDownPayment ?? getDownPaymentValue(leaseDownPayment, settings, type, 'leasing'),
    financeDownPaymentPercentage: financeDownPaymentPercentage ?? getPercentageValue(financeDownPaymentPercentage, settings, type, 'financing'),
    leaseDownPaymentPercentage: leaseDownPaymentPercentage ?? getPercentageValue(leaseDownPaymentPercentage, settings, type, 'leasing'),
    selectedLeaseTerm: selectedLeaseTerm ?? dealerSelectedLeaseTerm,
    selectedLeaseMileage: selectedLeaseMileage ?? dealerSelectedLeaseMileage,
    leaseMileageOptions: leaseMileageOptions ?? dealerLeaseMileageOptions,
    leaseTermOptions: leaseTermOptions ?? dealerLeaseTermOptions,
    financeTermOptions: financeTermOptions ?? defaultFinanceTermOptions,
    interestRate: {
      ...interestRate,
      [listingType]: interestRate?.[listingType] ?? defaultInterestRates[listingType]
    },
    creditLowScore
  };
};
export { getTransformedSelectedCriteria as default };
